import React from 'react';
import PropTypes from 'prop-types';
import { LightBox as LightBoxContainer } from '../lightbox/lightbox';
import { getPriceForAll } from '../../../_modules/product/get_price_for_all';
import { Table } from './structure/table';
import { Products } from './rows/products';
import Translation from '../translation/translation';
import { GoToCheckout } from './rows/go_to_checkout';

export const LightBox = props => {
    const { products } = props;
    const allItemsPrice = getPriceForAll(products);

    const rows = [
        getProductsRow(props, allItemsPrice),
    ];
    const isCartPage = location.href.indexOf('/cart/') !== -1;
    const isCheckoutPage = location.href.indexOf('/checkout/') !== -1;
    let headerTitle = isCartPage ? 'sidebar-light-box-header' : 'sidebar-light-box-header-non-cart';

    return (
        <LightBoxContainer
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={[
                'lightbox--sidebar-light-box'
            ]}
        >
            <div className="sidebar-light-box__header">
                <Translation translationKey={headerTitle} />
            </div>

            <div className="sidebar-light-box">
                <Table
                    rows={rows}
                />

                {isCheckoutPage
                    ? (
                        <button
                            className="sidebar-light-box__close"
                            onClick={props.onClose}
                        >Close</button>
                    )
                    : (isCartPage
                        ? <Table
                            rows={[
                                <GoToCheckout
                                    fittingStationAllowed={false}
                                    hasFitting={true}
                                    hasBorder={true}
                                    baseUrl={`${location.origin}${TYROOLA.globals.baseUrl}`}
                                    key="GoToCheckout"
                                />
                            ]} />
                        : <>
                            <button
                                style={{ marginBottom: '20px' }}
                                className="sidebar-light-box__close"
                                onClick={() => location.href = `${location.origin}${TYROOLA.globals.baseUrl}/cart`}
                            ><Translation translationKey='cart-my-cart' /></button>

                            <Table
                                rows={[
                                    <GoToCheckout
                                        fittingStationAllowed={true}
                                        hasFitting={true}
                                        hasBorder={true}
                                        baseUrl={`${location.origin}${TYROOLA.globals.baseUrl}`}
                                        key="GoToCheckout"
                                    />
                                ]} />
                        </>
                    )
                }
            </div>
        </LightBoxContainer>
    );
};

LightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onMatesRatesLearnMoreClick: PropTypes.func.isRequired,
    cartProducts: PropTypes.arrayOf(PropTypes.object),
};

LightBox.defaultProps = {
    cartProducts: [],
};

const getProductsRow = (props, allItemsPrice) => (
    <Products
        products={props.products}
        currencyIsoCode={props.currencyIsoCode}
        showDetails={true}
        allItemsPrice={allItemsPrice}
        onMatesRatesLearnMoreClick={props.onMatesRatesLearnMoreClick}
        onShowProductDetailsClick={props.onShowProductDetailsClick}
        cartProducts={props.cartProducts}
        shipments={props.shipments}
        key="Products"
    />
);
